/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createContext, useEffect, useRef, useState } from "react";
import CartSection from "./Cart/CartSection";
import FamilyGroups from "./FamilyGroups/Index";
import FamilyGroupDetails from "./FamilyGroup/FamilyGroupDetails";
import apiGateWay from "../serviceHandler";
import Loader from "./Common/Loader";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "./Common/Modal";
import Swal from "sweetalert2";

export const AppContext = createContext();

const Index = () => {
  const urlParams = useParams();
  const myRef = useRef(null);
  const navigate = useNavigate();
  const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
  useEffect(() => {
    if (Object.keys(urlParams).length) {
      sessionStorage.setItem("urlParams", JSON.stringify(urlParams));
    }
    if (!tableData) {
      navigate("/home");
    }
    getMenuData();
    getRvcList();
  }, [urlParams]);

  const [menuData, setMenuData] = useState([]);
  const [filteredMenuData, setFilteredMenuData] = useState([]);
  const [loaderItems, setLoaderItems] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [selectedFamilyGroup, setSelectedFamilyGroup] = useState("");
  const [selectedFamilySubGroup, setSelectedFamilySubGroup] = useState("");
  const [searchText, setSearchText] = useState("");
  const [userFormData, setUserFormData] = useState({});
  const [guestData, setGuestData] = useState({});
  const [guestOrderData, setGuestOrderData] = useState({});
  const [toasterData, setToasterData] = useState({});
  const [showImage, setShowImage] = useState(false);
  const [viewOrders, setViewOrders] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [rvcList, setRvcList] = useState([]);
  const [rvcRoom, setrvcRoom] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [timeValid, setTimeValid] = useState({
    isServiveOpen: true,
    isModalOpen: false,
  });

  const [addCondimentsModal, setAddCondimentsModal] = useState({});
  useEffect(() => {
    if (toasterData.type) {
      setTimeout(() => {
        setToasterData({});
      }, 3000);
    }
  }, [toasterData]);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      if (!cartItems.length) {
        return;
      }
      e.returnValue = true;
    };
    if (!cartItems.length) {
      window.removeEventListener("beforeunload", handler);
    }
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [cartItems]);

  let temp = {};
  useEffect(() => {
    temp = userFormData;
  }, [userFormData]);

  const convertFrom24To12Format = (time24) => {
    // console.log(time24)
    const matchResult = time24.match(/([0-9]{1,2}):([0-9]{2})/);
    if (matchResult) {
      const [sHours, minutes] = matchResult.slice(1);
      const period = +sHours < 12 ? "AM" : "PM";
      const hours = +sHours % 12 || 12;
      return `${hours}:${minutes} ${period}`;
    }
  };

  const checkOperationalTimings = (rvcData = [], shouldModalOpen = false) => {
    const currentRvc = rvcData.find(
      (rvc) => rvc.code === Number(urlParams.rvc),
    );
    if (currentRvc) {
      const { rvcStart_time, rvcStop_time } = currentRvc;

      const currentDate = new Date();

      let inactiveStartDate = new Date(currentDate.getTime());
      inactiveStartDate.setHours(rvcStart_time.split(":")[0]);
      inactiveStartDate.setMinutes(rvcStart_time.split(":")[1]);
      inactiveStartDate.setSeconds(rvcStart_time.split(":")[2]);

      let inactiveEndDate = new Date(currentDate.getTime());
      inactiveEndDate.setHours(rvcStop_time.split(":")[0]);
      inactiveEndDate.setMinutes(rvcStop_time.split(":")[1]);
      inactiveEndDate.setSeconds(rvcStop_time.split(":")[2]);

      // Check if current time is outside the inactive period
      const isActive =
        currentDate < inactiveStartDate || currentDate > inactiveEndDate;

      const inactiveStartTime = `${
        new Date(
          null,
          null,
          null,
          rvcStart_time.split(":")[0],
          rvcStart_time.split(":")[1],
        ).getHours() || "00"
      }:${
        new Date(
          null,
          null,
          null,
          rvcStart_time.split(":")[0],
          rvcStart_time.split(":")[1],
        ).getMinutes() || "00"
      }`;

      const inactiveEndTime = `${new Date(
        null,
        null,
        null,
        rvcStop_time.split(":")[0],
        rvcStop_time.split(":")[1],
      ).getHours()}:${
        new Date(
          null,
          null,
          null,
          rvcStop_time.split(":")[0],
          rvcStop_time.split(":")[1],
        ).getMinutes() || "00"
      }`;

      setTimeValid({
        isServiveOpen: isActive,
        isModalOpen: shouldModalOpen && !isActive,
        start: convertFrom24To12Format(inactiveStartTime),
        close: convertFrom24To12Format(inactiveEndTime),
      });
    }
  };

  const executeScroll = () => {
    myRef.current.scrollIntoView();
  };

  const searchItem = () => {
    if (!searchText.trim().length) {
      getMenuData();
      return false;
    }
    try {
      const tempMenuData = new Array(...menuData);
      const searchedList = tempMenuData
        .map(({ familyGroup, ...mListItem }) => {
          return {
            ...mListItem,
            familyGroup: familyGroup.map(({ menuItem, ...fg }) => {
              return {
                ...fg,
                menuItem: menuItem.filter((mItem) =>
                  mItem.name.toLowerCase().includes(searchText.toLowerCase()),
                ),
              };
            }),
          };
        })
        .filter(
          (mi) =>
            mi.familyGroup.filter((fg) => fg.menuItem.length > 0).length > 0,
        );
      setFilteredMenuData(searchedList);
    } catch (error) {
      setFilteredMenuData(menuData);
      console.log(`searchItem error`, error);
    }
  };

  const handleLoader = (items, action) => {
    switch (action) {
      case "add":
        setLoaderItems([...loaderItems, ...items]);
        break;
      case "remove":
        setLoaderItems(loaderItems.filter((item) => !items.includes(item)));
        break;
      default:
        break;
    }
  };

  const getMenuData = async () => {
    let rvcnumber = Number(urlParams.rvc);
    let zone = Number(urlParams.zone);
    let tableNumer = Number(urlParams.tableNumer);
    try {
      handleLoader(["getMenuData"], "add");
      const response = await apiGateWay.get(
        `/keyconnect/simphony/GetMenuItems?LocationId=${tableNumer}&Zone=${zone}&RvcCode=${rvcnumber}`,
      );
      handleLoader(["getMenuData"], "remove");
      if (response.status === 200) {
        setMenuData(response?.data?.result?.data || []);
        setFilteredMenuData(response?.data?.result?.data || []);
      } else {
        setMenuData([]);
        setFilteredMenuData([]);
      }
    } catch (error) {
      setMenuData([]);
      setFilteredMenuData([]);
      handleLoader(["getMenuData"], "remove");
      console.log(`getMenuData error`, error);
    }
  };

  const getRvcList = async () => {
    try {
      handleLoader(["getRvcList"], "add");
      const response = await apiGateWay.get("/keyconnect/simphony/GetRVCs");
      handleLoader(["getRvcList"], "remove");
      if (response.status === 200) {
        setRvcList(response?.data?.result?.data || []);

        const data = response?.data?.result?.data.filter(
          (item) => item?.code == urlParams.rvc,
        );
        if (data.length > 0) {
          if (data[0].type == "ROOMS") {
            setrvcRoom({
              status: true,
              number: urlParams.tableNumer,
            });
          }
        } else {
          throw new Error("RVC number Error!");
        }
        setTimeout(() => {
          checkOperationalTimings(response?.data?.result?.data || [], true);
        }, 1000);
      }
    } catch (error) {
      handleLoader(["getRvcList"], "remove");
      console.log(`getRvcList error`, error);
    }
  };

  const addGuest = async (data) => {
    try {
      handleLoader(["addGuest"], "add");
      const response = await apiGateWay.post(
        "/keyconnect/simphony/AddGuests",
        data,
      );
      handleLoader(["addGuest"], "remove");
      if (response.status === 200) {
        setGuestData(response?.data?.result[0] || {});
        createGuestOrder({
          guest: response?.data?.result[0] || {},
          checkname: data.checkname,
          guestCount: data.guestCount,
          roomNumber: data.RoomNumber,
        });
      } else {
        setGuestData({});
      }
    } catch (error) {
      setGuestData({});
      handleLoader(["addGuest"], "remove");
      console.log(`addGuest error`, error);
    }
  };

  const createGuestOrder = async ({
    guest,
    checkname,
    guestCount,
    roomNumber,
  }) => {
    if (!guest.id) return;
    const body = {
      Guest_Id: guest.id,
      TableNumber: Number(roomNumber),
      CurrentlyOccupied: Number(guestCount),
      LocationID: Number(urlParams.tableNumer),
      RvcID: Number(urlParams.rvc),
    };
    try {
      handleLoader(["createGuestOrder"], "add");
      const response = await apiGateWay.post(
        "/keyconnect/simphony/CreateGuestOrder",
        body,
      );
      handleLoader(["createGuestOrder"], "remove");
      if (response.status === 200) {
        setGuestOrderData(response?.data?.result[0] || {});
        proceedToCheckout({
          guest: { ...guest, checkname, guestCount, roomNumber },
          guestOrder: response?.data?.result[0] || {},
        });
      } else {
        setGuestOrderData([]);
      }
    } catch (error) {
      setGuestOrderData([]);
      handleLoader(["createGuestOrder"], "remove");
      console.log(`createGuestOrder error`, error);
    }
  };

  const resetAppData = () => {
    getMenuData();
    setCartItems([]);
    setSelectedFamilyGroup("");
    setSelectedFamilySubGroup("");
    setSearchText("");
    setUserFormData({});
    setGuestData({});
    setGuestOrderData({});
    setToasterData({});
  };

  const proceedToCheckout = async ({ guest, guestOrder }) => {
    const postBody = {
      TableNumber: Number(guest.roomNumber),
      RevenueCenterObjectNum: Number(urlParams.rvc),
      OrderNumber: Number(guestOrder.orderNo),
      Guest_count: Number(guest.guestCount),
      checkname: guest.checkname,
      LocationID: parseInt(rvcList[0]?.location_Id),
      isEwallet: false,
      TenderMedia: {
        Code: 1,
        Name: "",
        Amount: 0.0,
      },
      MenuItems: cartItems?.map((item) => {
        return {
          itemCode: item.itemCode,
          Price: item.price,
          quantity: item.quantity,
          Comment: item.comment,
          Condiments: item?.condiments
            ?.filter((x) => x.quantity > 0)
            .map((item) => {
              return {
                ItemCode: item.itemCode,
                price: item.price,
                quantity: item.quantity,
              };
            }),
        };
      }),
    };
    const body = {
      TableNumber: Number(guest.roomNumber),
      RevenueCenterObjectNum: Number(urlParams.rvc),
      OrderNumber: Number(guestOrder.orderNo),
      OrderType: "New Check",
      Guest_count: Number(guest.guestCount),
      checkname: guest.checkname,
      LocationID: parseInt(rvcList[0]?.location_Id),
      orderMenuItems: cartItems?.map((item) => {
        return {
          itemCode: item.itemCode,
          Price: item.price,
          quantity: item.quantity,
          Comment: item.comment,
          Condiments: item?.condiments
            ?.filter((x) => x.quantity > 0)
            .map((item) => {
              return {
                ItemCode: item.itemCode,
                price: item.price,
                quantity: item.quantity,
              };
            }),
        };
      }),
    };

    try {
      handleLoader(["proceedToCheckout"], "add");
      const response = await apiGateWay.post(
        "/keyconnect/simphony/AddOrderItem",
        body,
      );
      const postResponse = await apiGateWay.post(
        "/keyconnect/simphony/PostCheck",
        postBody,
      );
      console.log("postResponse", postResponse);
      handleLoader(["proceedToCheckout"], "remove");
      // if (response.status === 200) {
      //   resetAppData();
      //   setToasterData({
      //     type: "success",
      //     message: "You have placed your order!",
      //   });
      // } else {
      //   resetAppData();
      //   setToasterData({
      //     type: "error",
      //     message: "Failed to place your order!",
      //   });
      // }
      resetAppData();
      // setToasterData({
      //   type: "You have placed your order!" ? "success" : "error",
      //   message:
      //     response.status === 200
      //       ? "You have placed your order!"
      //       : "Failed to place your order!",
      // });
      if (response.status === 200 && postResponse.status === 200) {
        Swal.fire({
          title: "Success",
          text: "You have placed your order!",
          icon: "success",
          confirmButtonColor: "#0f145b",
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to payment page
            navigate("/ezmenu/payment", {
              state: {
                amount: "100.00",
                currency: "SAR"
              },
            });
          }
        });
        setIsChecked(false);
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to place your order!",
          icon: "error",
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to payment page
            navigate("/ezmenu/payment", {
              state: {
                amount: "100.00",
                currency: "SAR"
              },
            });
          }
        });;

        setIsChecked(false);
      }
    } catch (error) {
      resetAppData();
      handleLoader(["proceedToCheckout"], "remove");
      // setToasterData({ type: "error", message: "Failed to place your order!" });

      Swal.fire({
        title: "Error!",
        text: "Failed to place your order!",
        icon: "error",
      });
      console.log(`proceedToCheckout error`, error);
    }
  };

  useEffect(() => {
    searchItem();
  }, [searchText]);

  const handleCartActions = (action, item) => {
    const { itemCode } = item;
    const index = cartItems.findIndex((e) => e.itemCode === itemCode);

    if (index === -1) return; // Early return if item is not found

    const updatedCartItem = {
      ...cartItems[index],
    };

    switch (action) {
      case "increment":
        const incrementedItem = {
          ...updatedCartItem,
          quantity: updatedCartItem.quantity + 1,
        };
        setCartItems([
          ...cartItems.slice(0, index),
          incrementedItem,
          ...cartItems.slice(index + 1),
        ]);
        break;

      case "decrement":
        if (updatedCartItem.quantity === 1) {
          handleCartActions("remove", updatedCartItem);
        } else {
          const decrementedItem = {
            ...updatedCartItem,
            quantity: updatedCartItem.quantity - 1,
          };

          // Update condiments
          const updatedCondimentsForDecrement =
            decrementedItem.condiments?.map((condiment) => ({
              ...condiment,
              quantity:
                condiment.quantity === updatedCartItem.quantity
                  ? condiment.quantity
                  : condiment.quantity,
            })) || null;

          setCartItems([
            ...cartItems.slice(0, index),
            { ...decrementedItem, condiments: updatedCondimentsForDecrement },
            ...cartItems.slice(index + 1),
          ]);
        }
        break;

      case "remove":
        setCartItems([
          ...cartItems.slice(0, index),
          ...cartItems.slice(index + 1),
        ]);
        break;

      default:
        break;
    }
  };

  const getTotal = () => {
    let sum = 0;
    cartItems.forEach((it) => (sum = sum + Number(it.quantity)));
    return sum;
  };

  const appStoreData = {
    menuData,
    filteredMenuData,
    cartItems,
    selectedFamilyGroup,
    selectedFamilySubGroup,
    searchText,
    rvcList: rvcList || [],
    timeValid,
    setTimeValid,
    setShowImage,
    setSearchText,
    setSelectedFamilyGroup,
    setSelectedFamilySubGroup,
    setCartItems,
    handleCartActions,
    proceedToCheckout,
    addGuest,
    setUserFormData,
    addCondimentsModal,
    setAddCondimentsModal,
    isChecked,
    setIsChecked,
  };

  const getTotalOrderPrice = () => {
    const price = ordersList.reduce((a, b) => a + b.price, 0);
    return Number(price).toFixed(2);
  };
  console.log("rvcList", rvcList);
  const renderViewOrderModal = () => {
    return (
      <div className="p-3">
        <div className="pt-2 pb-1 px-2">
          {ordersList?.length ? (
            // ? ordersList.map(item => {
            // 	return <div className="mb-2 flex-column added-item no-border" key={item.id}>
            // 		<div className="row d-flex align-items-center">
            // 			<div className="col-md-8">
            // 				<p className="m-0">{item.name} </p>
            // 			</div>
            // 			<div className="col-md-4">
            // 				<div className="m-0">
            // 					<span className="f-11 pa-2">
            // 						<b>{item.quantity || 0}</b>
            // 					</span>
            // 				</div>
            // 			</div>
            // 		</div>
            // 	</div>
            // })
            <div className="mb-2 flex-column added-item no-border">
              <div className="row d-flex align-items-center">
                <table>
                  <tr>
                    <th>Item</th>
                    <th>Count</th>
                  </tr>
                  {ordersList.map((item) => {
                    return (
                      <tr>
                        <td>{item.name}</td>
                        <td style={{ textAlign: "right" }}>
                          {item.quantity ? Number(item.quantity).toFixed(2) : 0}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td />
                    <td style={{ textAlign: "right" }}>
                      Sum: {<b>AED {getTotalOrderPrice()}</b>}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center">
              No orders are placed so far
            </div>
          )}
        </div>
      </div>
    );
  };

  const viewOrder = async () => {
    setViewOrders(true);
    try {
      const params = {
        LocationID: 1,
        TableNumber: Number(urlParams.tableNumer),
        RevenueCenterObjectNum: Number(urlParams.rvc),
        MobileNumber: Number(tableData.MobileNumber),
      };
      handleLoader(["viewOrder"], "add");
      const response = await apiGateWay.get(
        `/keyconnect/simphony/ViewOrders?${new URLSearchParams(params)}`,
      );
      const resultList = response.data.result;
      let temp = [];
      resultList.forEach((item) => {
        temp = [...temp, ...item.orderMenuItems];
      });
      handleLoader(["viewOrder"], "remove");
      if (response.status === 200) {
        setOrdersList(temp);
      }
    } catch (error) {
      handleLoader(["viewOrder"], "remove");
      console.log(`viewOrder error`, error);
    }
  };
  return (
    <AppContext.Provider value={appStoreData}>
      {viewOrders ? (
        <Modal
          title="Active Orders"
          // onOk={() => {
          //     setCartItems(updatedCartItems);
          //     setAddCommentModal({})
          // }}
          onClose={() => setViewOrders(false)}
          okText="Submit"
          cancelText="Cancel"
          modalBody={renderViewOrderModal()}
          isFooterVisible={false}
        />
      ) : null}
      {timeValid.isModalOpen ? (
        <Modal
          title="Outlet Not Open"
          onOk={() => {
            setTimeValid({
              ...timeValid,
              isModalOpen: false,
            });
          }}
          onClose={() =>
            setTimeValid({
              ...timeValid,
              isModalOpen: false,
            })
          }
          okText="Ok"
          modalBody={
            <div style={{ color: "tomato" }}>
              <h5>
                {rvcList[0]?.name} is currently not operational. Please seek
                assistance from a staff member.
              </h5>
            </div>
          }
          isFooterVisible={false}
        />
      ) : null}
      <div className="outer-cover">
        <div
          className="food-img-modal"
          style={
            showImage
              ? {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "rgb(100 100 100 / 48%)",
                  zIndex: 999,
                }
              : { display: "none" }
          }
        >
          <div className="moodal-content" onClick={() => setShowImage(null)}>
            <img
              src={showImage?.image}
              alt="Butter Chicken Combo"
              className="food-modal-img"
              title={showImage?.name || "No image for this item"}
            />
            <div className="close-btn" onClick={() => setShowImage(null)}>
              <svg
                viewPort="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="1"
                  y1="11"
                  x2="11"
                  y2="1"
                  stroke="black"
                  strokeWidth="2"
                />
                <line
                  x1="1"
                  y1="1"
                  x2="11"
                  y2="11"
                  stroke="black"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
        {loaderItems.length ? <Loader /> : null}
        <div
          id="snackbar"
          className={`toaster-cover ${toasterData.type || ""} ${
            toasterData.type ? "show" : ""
          }`}
        >
          <span>{toasterData.message}</span>
        </div>
        <header>
          <div className="navigation d-flex">
            <span
              className="d-flex"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            >
              <img
                src="/images/logo-white.png"
                alt="EZmenu.svg"
                style={{ width: "100px" }}
              />
            </span>
            <div className="d-flex align-items-center justify-content-center">
              {/* <h5 className="view-order d-none d-md-block d-flex flex-row"> */}
              {/*   <i className="far fa-clock" /> */}
              {/*   <span className="pl-2" style={{ fontSize: "0.8rem" }}> */}
              {/*     {`${timeValid.start || ""} - ${timeValid.close || ""} `} */}
              {/*   </span> */}
              {/* </h5> */}
              {/**/}
              {/* <h5 className="view-order items-hide" onClick={viewOrder}> */}
              {/*   View Order */}
              {/* </h5> */}
              <a
                href=""
                className="notification"
                onClick={(e) => {
                  e.preventDefault();
                  executeScroll();
                }}
                style={{ cursor: "default" }}
              >
                <span>{getTotal()}</span>
              </a>
            </div>
          </div>
        </header>
        {/* <div className="mobile-sub-header d-block d-md-none"> */}
        {/*   <div className="w-100 d-flex flex-md-row align-items-center justify-content-between"> */}
        {/*     <h5 className="view-order d-flex flex-row" onClick={viewOrder}> */}
        {/*       <i className="far fa-clock"></i> */}
        {/*       <span className="pl-2" style={{ fontSize: "0.8rem" }}>{`${ */}
        {/*         timeValid.start || "" */}
        {/*       } - ${timeValid.close || ""} `}</span>{" "} */}
        {/*     </h5> */}
        {/*     <div className="view-order d-flex flex-row align-items-center justify-content-end"> */}
        {/*       <h5 className="view-order" onClick={viewOrder}> */}
        {/*         View Order */}
        {/*       </h5> */}
        {/*     </div> */}
        {/*   </div> */}
        {/* </div> */}
        <div className="container main-container">
          <div className="row">
            <FamilyGroups />
            <FamilyGroupDetails />
            <CartSection rvcRoom={rvcRoom} refelement={myRef} />
          </div>
        </div>
      </div>
    </AppContext.Provider>
  );
};

export default Index;
